import { Injectable } from "@angular/core";
import { Respuesta } from "../../models/respuesta";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})

export class PagosService {

  private baseUri = "https://suratech-ventas-xapi-qa.us-e1.cloudhub.io/v1/pago/url";
  private _body = {
        "idCotizacion": "910000030088",
        "codProducto": "ARRENDAMIENTODIGITAL",
        "fechaPago": "2024-01-28",
        "tarifa": 600000,
        "tokenizar": false,
        "habilitarRenovacionAutomatica": false,
        "referencia": "10000034",
        "habilitarOtroPagador": false,
        "urlRetornoLogo": "/v2/sura/proteccion-digital-personas",
        "urlRetorno": "https://suratecharrendamientos.z13.web.core.windows.net/",
        "tenant": "sura",
        "listaDeDescuentos": [],
        "metadata": [
            {
                "dato": "Producto",
                "valor": "Arrendamiento Digital"
            },
            {
                "dato": "Plan",
                "valor": "Plan Plus"
            },
            {
                "dato": "Forma de pago",
                "valor": "Pago único"
            },
            {
                "dato": "Prima",
                "valor": "504201.68"
            },
            {
                "dato": "Impuestos",
                "valor": "95798.32"
            },
            {
                "dato": "Total a pagar",
                "valor": "600000"
            }
        ],
        "pagador": {
            "nombres": "JORGE LUIS", //Acá va el nombre ingresado en la pantalla inicial
            "apellidos": "ARGOTE CASSIANI", //Acá va el apellido ingresado en la pantalla inicial
            "tipoDocumento": "C",
            "numeroDocumento": "4376533", //Acá va el número de cédula digitado
            "codigoCiudad": "",
            "ciudad": "MEDELLIN",
            "departamento": "ANTIOQUIA",
            "direccion": "",
            "pais": "57",
            "correoElectronico": "fake@mail.com",
            "telefono": "3226663900"
        },
        "mediosPagoHabilitados": {
            "tarjetaCredito": true,
            "tuya": false,
            "exito": false,
            "pse": true,
            "botonBancolombia": true
        },
        "esFinanciado": "false",
        "tarifaTotal": 0,
        "claveReferencia": null,
        "encuestaSatisfaccion": null
    };

  constructor(private http: HttpClient) { }

  public getPago() {
    let headers = new HttpHeaders({
                    'Content-Type':'application/json',
                    'jwt': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2ODc0NzEwMTMsImV4cCI6MTc1MDU0MzAxMywiYXVkIjoic3VyYXRlY2gtdmVudGFzLXhhcGktcWEudXMtZTEuY2xvdWRodWIuaW8iLCJzdWIiOiJqcm9ja2V0QGV4YW1wbGUuY29tIiwiR2l2ZW5OYW1lIjoiSm9obm55IiwiU3VybmFtZSI6IlJvY2tldCIsIkVtYWlsIjoianJvY2tldEBleGFtcGxlLmNvbSIsIlJvbGUiOlsiTWFuYWdlciIsIlByb2plY3QgQWRtaW5pc3RyYXRvciJdfQ.-wIbdmIY2q84EnTFLG_bnXt5_8wTaqBjp8yYo6fSdJE',
                    'Access-Control-Allow-Origin': '*',
                    'Accept': '*/*'
                  });
    const respuesta = this.http.post<Respuesta>(this.baseUri, this._body, {headers: headers});
    return respuesta;
  }
}
